// extracted by mini-css-extract-plugin
export default {"textArea":"TextAreaForm_textArea__SqOpC","currentLength":"TextAreaForm_currentLength__LTVQy","maxLength":"TextAreaForm_maxLength__tzv56"};